import { render, staticRenderFns } from "./CustomerPriceList.vue?vue&type=template&id=5dbb064c&"
import script from "./CustomerPriceList.vue?vue&type=script&lang=js&"
export * from "./CustomerPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports